import SDMaskedInput from '@/shared/components/SDComponentsNewDesign/SDMaskedInput/SDMaskedInput'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPage/getError'
import isValidDate from '@/shared/tools/isValidDate'
import useLastHolderFields from './useLastHolderFields'

const PropertyDate = () => {
  const { t, errors, isEditable, lastHolderPropertyDate, updateAddress } = useLastHolderFields()

  const handleBlur = (value: string | null) => {
    if (!value || value.replace(/\s/g, '').length !== 10) return

    const [day, month, year] = value.split('/')
    const parsed = new Date(`${month}/${day}/${year} UTC`)

    updateAddress({ last_holder_property_date: isValidDate(parsed) ? value : '' })
  }

  return (
    <SDFormControl error={getError('last_holder_property_date', errors)}>
      <SDMaskedInput
        label={t('subscriptionForm:address_module.last_holder_fields.property_date.label')}
        disabled={isEditable === false}
        placeholder={t('subscriptionForm:address_module.last_holder_fields.property_date.placeholder')}
        mask='99/99/9999'
        currentValue={lastHolderPropertyDate ?? ''}
        error={getError('last_holder_property_date', errors)}
        onBlur={handleBlur}
        overrides={undefined}
        status={undefined}
      />
    </SDFormControl>
  )
}

export default PropertyDate
